import { FC } from 'react';
import { Card } from '@/components/ui/card';
import { Clock, CheckCircle2, X } from 'lucide-react';
import { Progress } from '@/components/ui/progress';

interface ActivityRequirementProps {
  activityMonths: number;
}

export const ActivityRequirement: FC<ActivityRequirementProps> = ({ activityMonths }) => {
  const hasMetRequirement = activityMonths >= 3;

  return (
    <Card className="p-4 bg-gradient-to-br from-secondary/5 to-transparent border-secondary/10">
      <div className="flex items-center gap-3 mb-3">
        <Clock className="h-5 w-5 text-secondary" />
        <h3 className="font-semibold text-gray-800">Tiempo Premium</h3>
      </div>
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          {hasMetRequirement ? (
            <CheckCircle2 className="h-5 w-5 text-green-500 shrink-0" />
          ) : (
            <X className="h-5 w-5 text-red-500 shrink-0" />
          )}
          <span className="text-sm text-gray-600">
            Mínimo 3 meses con suscripción premium activa
          </span>
        </div>
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="font-medium">Progreso: {activityMonths} {activityMonths === 1 ? 'mes' : 'meses'}</span>
            <span className="text-gray-500">Meta: 3 meses</span>
          </div>
          <Progress 
            value={(activityMonths / 3) * 100} 
            className="h-2 bg-gray-100"
          />
          {!hasMetRequirement && (
            <div className="space-y-1">
              <p className="text-sm text-gray-600">
                Te faltan {3 - activityMonths} {3 - activityMonths === 1 ? 'mes' : 'meses'} de suscripción premium
              </p>
              <p className="text-xs text-gray-500">
                Mantén tu suscripción premium activa para acceder al programa de partners
              </p>
            </div>
          )}
          {hasMetRequirement && (
            <p className="text-sm text-green-600">
              ¡Felicitaciones! Has cumplido con el tiempo mínimo requerido
            </p>
          )}
        </div>
      </div>
    </Card>
  );
};